module.exports = __webpack_public_path__ + "img/imagem6.7ea83b38.svg";